/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { useCallback, useEffect } from 'react';
import { ProcessInstanceTokenAction } from 'domain/gpo/cockpit/instance/Show/token/processInstanceTokenService';
import { TextInput, FormFieldsData, useFormContext } from 'framework/form';
import { useMessageService } from 'framework/ui/Message';
import ModificationTokenButtonLayout from 'domain/gpo/cockpit/instance/Show/token/shared/ModificationTokenButtonLayout';

interface ModificationTokenPositionFormProps {
  action: ProcessInstanceTokenAction;
  processInstanceId: string;
}

const ModificationTokenPositionForm = ({ action, processInstanceId }: ModificationTokenPositionFormProps) => {
  const { setFormData = (newData: FormFieldsData) => {}, setFormErrors = (errors: FormFieldsData) => {} } =
    useFormContext();
  const { cleanMessage } = useMessageService();

  const cleanData = useCallback(() => {
    setFormData({
      instanceId: processInstanceId,
    });
    setFormErrors({});
    cleanMessage();
  }, [cleanMessage, processInstanceId, setFormData, setFormErrors]);

  useEffect(() => {
    cleanData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  const fields = useCallback(() => {
    switch (action) {
      case ProcessInstanceTokenAction.CREATE:
        return CreateTokenFields;
      case ProcessInstanceTokenAction.RECREATE:
        return RecreateTokenFields;
      case ProcessInstanceTokenAction.MOVE:
        return MoveTokenFields;
      case ProcessInstanceTokenAction.KILL:
        return KillTokenFields;
      default:
        return <></>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  const CreateTokenFields = (
    <>
      <TextInput source="instanceId" label="Process instance ID" isRequired disabled />
      <TextInput source="activityId" label="Activity ID" isRequired />
    </>
  );
  const RecreateTokenFields = (
    <>
      <TextInput source="instanceId" label="Process instance ID" value={processInstanceId} isRequired disabled />
      <TextInput source="activityId" label="Activity ID" isRequired />
    </>
  );
  const MoveTokenFields = (
    <>
      <TextInput source="instanceId" label="Process instance ID" value={processInstanceId} isRequired disabled />
      <TextInput source="fromActivityId" label="From activity ID" isRequired />
      <TextInput source="toActivityId" label="To activity ID" isRequired />
    </>
  );
  const KillTokenFields = (
    <>
      <TextInput source="instanceId" label="Process instance ID" value={processInstanceId} isRequired disabled />
      <TextInput source="activityInstanceId" label="Activity instance ID" isRequired />
    </>
  );

  return (
    <CreatePageLayout title=" " buttons={<ModificationTokenButtonLayout handleCleanClick={cleanData} />}>
      {fields()}
    </CreatePageLayout>
  );
};

export default ModificationTokenPositionForm;
